import React from 'react';
import {Route, Routes} from "react-router-dom"
import Report from '../components/Task/Report';
import Task from '../components/Task/Task';
import Client from "../components/Client/client";
import AddClient from "../components/Client/AddClint";
import Service from "../components/Service/Service";
import Users from "../components/Users/Users";
import UsersLists from "../components/Users/UsersLists";
import AssignmentContainer from "../components/Assignments/AssignmentAddContainer";
import TaskFormContainer from "../components/Task/TaskFormContainer";
import LoginForm from "../components/Auth/LoginForm";
import Dashboard from '../components/Home/Dashboard';
import AddService from '../components/Service/AddService';
import Complain from '../components/complain/complain';
import Market from '../components/marketintellegency/Market';
import TableListMarket from '../components/marketintellegency/TableListMarket';
import Order from '../components/order/Order';
import RegisterForm from '../components/Auth/RegisterForm';
import ComplainTableList from '../components/complain/ComplainTableList';
import RegistrationTrader from '../components/TraderRegistration/RegistrationTrader';
import RegistrationTraderSwahili from '../components/TraderRegistration/RegistrationTraderSwahili';



function AdminRoute(props) {
    return (
       <Routes>
      <Route path='/' element={<Dashboard/>}></Route>
      <Route path='/task' element={<Task/>}></Route> 
      <Route path='/report/:id' element={<Report/>}></Route>
      <Route path="/ClientList" element={<Client />}></Route>
      <Route path="/Add-Client" element={<AddClient />}></Route>
      <Route path="/Service" element={<Service />}></Route>
      <Route path="/Add-user" element={<Users />}></Route>
      <Route path="/Users-List" element={<UsersLists />}></Route>
      <Route path="/Add-Assignment" element={<AssignmentContainer />}></Route>
      <Route path="/Add-Task" element={<TaskFormContainer />}></Route>
      <Route path="/addService" element={<AddService/>}></Route>
      <Route path="/login" element={<LoginForm />}></Route>
      <Route path="/complain" element={<Complain/>}></Route>
      <Route path="/add-market-itelligency" element={<Market/>}></Route>
      <Route path="/market-itelligency-List" element={<TableListMarket/>}></Route>
      <Route path="/order-list" element={<Order/>}></Route>
      <Route path="/register" element={<RegisterForm />} />
      <Route path="/complain-list" element={<ComplainTableList />} />
       <Route path="/cross-border-registration" element={<RegistrationTrader />} />
       <Route path="/cross-border-registration-sw" element={<RegistrationTraderSwahili />} />

       </Routes> 
    );
}

export default AdminRoute;